import React, { useMemo, useState, useCallback } from 'react'
import BigNumber from 'bignumber.js'
import styled from 'styled-components'
import useI18n from 'hooks/useI18n'
import { useTokenBalance } from 'hooks/useTokenBalance'
import { Button, Flex, Text, useModal } from '@pancakeswap-libs/uikit'
import ConfirmationModal from 'components/Modal/ConfirmationModal'
import { useInject, useTransferOwnership, useRenounce, useEnd, useSetFeeAddress, useUpdateEmissionRate } from '../hooks/useRanches'
import InjectModal from './InjectModal'
import TransferOwnershipModal from './TransferOwnershipModal'
import SetFeeAddressModal from './SetFeeAddressModal'
import ChangeEmissionModal from './ChangeEmissionModal'

const Action = styled.div`
    padding-top: 5px;
`

interface CardActionsProps {
    ranch: any,
    account?: string
}

const CardActions: React.FC<CardActionsProps> = ({ ranch, account }) => {
    const TranslateString = useI18n();
    const { address, owner, token, userInfo, depositFeeRate, emissionPerBlock } = ranch;
    const isOwner = account && owner && owner.toLowerCase() === account.toLowerCase();
    
    // Transfer Ownership
    const onTransferOwnershipSubmit = useTransferOwnership(address);
    const onTransferOwnershipModalConfirm = async (newOwner) => {
        return onTransferOwnershipSubmit(newOwner);
    };
    const [onTransferOwnershipStart] = useModal(<TransferOwnershipModal onConfirm={onTransferOwnershipModalConfirm} />)
    
    // Set Fee Address
    const onSetFeeAddressSubmit = useSetFeeAddress(address);
    const onSetFeeAddressModalConfirm = async (newFeeAddress) => {
        return onSetFeeAddressSubmit(newFeeAddress);
    };
    const [onSetFeeAddressStart] = useModal(<SetFeeAddressModal onConfirm={onSetFeeAddressModalConfirm} />)

    // Renounce
    const [requestedRenounce, setRequestedRenounce] = useState(false)
    const onRenounce = useRenounce(address);
    const handleRenounce = useCallback(async () => {
        try {
            setRequestedRenounce(true)
            await onRenounce()
            setRequestedRenounce(false)
        } catch (e) {
            console.error(e)
        }
    }, [onRenounce])

    // End
    const onEnd = useEnd(address);
    const [onEndStart] = useModal(<ConfirmationModal content={TranslateString(1236, "You are going to end a ranch and retrieve the remaining balance. Please communicate well with the community if people have already staked. Once the ranch is ended, there will be no way to reactivate it!")} onConfirm={async()=>{return onEnd();}} />)

    // Inject
    const tokenBalance = userInfo && userInfo.tokenBalance || new BigNumber(0);
    const onInjectSubmit = useInject(address, token);
    const onInjectModalConfirm = async (amount) => {
        return onInjectSubmit(new BigNumber(amount));
    };
    const [onInjectStart] = useModal(<InjectModal max={tokenBalance.toFixed()} token={token} isOwner={isOwner} onConfirm={onInjectModalConfirm} />)

    // Change Emission
    const onChangeEmissionSubmit = useUpdateEmissionRate(address, token);
    const onChangeEmissionModalConfirm = async (amount) => {
        return onChangeEmissionSubmit(new BigNumber(amount));
    };
    const [onChangeEmissionStart] = useModal(<ChangeEmissionModal token={token} onConfirm={onChangeEmissionModalConfirm} emissionPerBlock={emissionPerBlock.toFixed()}/>)

    return (
        <Action>
            <Button mt="8px" fullWidth onClick={onInjectStart}>
                {TranslateString(442,'Add Balance')}
            </Button>
            {
                isOwner && (
                    <Button mt="8px" fullWidth onClick={onChangeEmissionStart}>
                        {TranslateString(1237,'Change Emission')}
                    </Button>
                )
            }
            {
                isOwner && depositFeeRate>0 && (
                    <Button mt="8px" fullWidth onClick={onSetFeeAddressStart}>
                        {TranslateString(1238,'Change Fee Address')}
                    </Button>
                )
            }
            {
                isOwner && (
                    <Button mt="8px" fullWidth onClick={onEndStart}>
                        {TranslateString(1239,'End')}
                    </Button>
                )
            }
            {
                isOwner && (
                    <Button mt="8px" fullWidth onClick={onTransferOwnershipStart}>
                        {TranslateString(400,'Transfer Ownership')} 
                    </Button>
                )
            }
            {
                isOwner && (
                    <Button mt="8px" fullWidth onClick={handleRenounce} disabled={requestedRenounce}>
                        {TranslateString(548,'Renounce Ownership')} 
                    </Button>
                )
            }
        </Action>
    );
}

export default CardActions
